import React, { Component } from 'react'
import { Row, Col, Card, Table, Button, Container, Form, Modal } from "react-bootstrap";
import CardLessDataTableWithSearch from '../datatables/CardLessDataTableWithSearch';
import FollowupHistoryModal from './FollowupHistoryModal';
import moment from "moment";



class LeadsModalDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            leadHistoryModal: false,
            rowData: [],
            employee_name: this.props.stateData?.employee_name
        }
    }

    coloumFunction = () => {
        let articlecolumns = [
            {
                dataField: "lead_name",
                text: "Lead Name",
                sort: true,
                formatter: this.leadHistory.bind(this)
            },
            {
                dataField: "lead_mobile",
                text: "Lead Mobile",
                sort: true,
            },
            // {
            //     dataField: "father_name",
            //     text: "Father Name",
            //     sort: true,
            // },
            // {
            //     dataField: "father_contact_no",
            //     text: "Father Mobile",
            //     sort: true,
            // },
            {
                dataField: "source_name",
                text: "Source",
                sort: true,
            },
            {
                dataField: "lead_status_type",
                text: "Lead Status",
                sort: true,
            },
        ];

        if (this.props.stateData.selectedOptionId == "1") {
            articlecolumns.push({
                dataField: "inserted_time",
                text: "Date",
                sort: true,
            })
        } else if (this.props.stateData.selectedOptionId == "2") {
            articlecolumns.push({
                dataField: "employee_name",
                text: "Assigned to",
                sort: true,
            })
        }

        return articlecolumns;

    }



    leadHistory(val, row) {
        console.log(row, "wwwwww");
        return this.props.stateData.selectedOptionId !== "2" ? (
            <>
                <div>
                    <a
                        href="#"
                        onClick={() => this.setState({ leadHistoryModal: true, rowData: row.history })}
                    >
                        {row.lead_name}
                    </a>
                </div>
            </>
        ) : row.lead_name
    }
    tableData(data) {
        console.log("eeeeeeeeee", this.props.getLeadStatusTypes)
        let returnData = [];
        data.map((item) => {
            let lead_status = this.props.getLeadStatusTypes?.filter((a) => a.id == item.lead_status_type_id)[0]?.lead_status_type
            const newObj = {
                lead_name: item.lead_name || "-",
                lead_mobile: item.lead_mobile || "-",
                father_name: item.father_name || "-",
                father_contact_no: item.father_contact_no || "-",
                source_name: item.source_name || "-",
                lead_status_type: lead_status || "-",
                history: item
            }
            if (this.props.stateData.selectedOptionId == "1") {
                let date = item.inserted_time != null ? moment.unix(item.inserted_time).format("DD-MM-YYYY") : "-";
                newObj.inserted_time = date;
            } else if (this.props.stateData.selectedOptionId == "2") {
                newObj.employee_name = item.employee_name;
            }
            returnData.push(newObj);
        });
        return returnData;
    }

    render() {

        console.log("leadsModal", this.props.stateData)

        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="modal-title">Leads Details</Modal.Title>
                </Modal.Header>
                <Container fluid>
                    <Modal.Body className="p-4">
                        <Row>
                            <Col lg={12} md={12} sm={12} className='mt-3'>

                                {
                                    this.props.stateData.rowData && this.props.stateData.rowData.length > 0 ? (

                                        <CardLessDataTableWithSearch
                                            parentData={this.tableData(this.props.stateData.rowData)}
                                            particlecolumns={this.coloumFunction()}
                                            name="leads"
                                        />

                                    ) : (
                                        <Col ls={12} md={12} sm={12}>
                                            <h4 className='mt-3 text-center'><span className="text-danger"> * </span> No data available</h4>
                                        </Col>
                                    )
                                }
                            </Col>
                        </Row>
                    </Modal.Body>
                    {
                        this.props.stateData.selectedOptionId != "2" ? (
                            <FollowupHistoryModal
                                stateData={this.state}
                                show={this.state.leadHistoryModal}
                                onHide={() => this.setState({ leadHistoryModal: false })}
                            />
                        ) : ""
                    }
                </Container>
            </Modal>)
    }
}
export default LeadsModalDetails